<div class="px-[12px]">
	<div class="custom-table overflow-x-auto mt-12px">
		<table class="mat-elevation-z8 bg-transparent w-full relative">
			<thead class="bg-light">
				<tr class="border-b-[1px] border-secondry-color-Gray">
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ 'PACKAGES.PACKAGES-LIST.PACKAGE-NAME' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ 'PACKAGES.PACKAGES-LIST.SERVICES' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ 'PACKAGES.PACKAGES-LIST.DATE' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ 'PACKAGES.PACKAGES-LIST.STATUS' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ 'PACKAGES.PACKAGES-LIST.BOOKING_ABILITY' | translate }}
					</td>
					<td
						class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ 'PACKAGES.PACKAGES-LIST.PRICE' | translate }}
					</td>
					<td></td>
				</tr>
			</thead>
			<tbody class="bg-grey-background">
				<tr
					*ngFor="
						let package of packages
							| paginate
								: {
										itemsPerPage: packageFilter?.paging?.pageSize,
										currentPage: packageFilter?.paging?.pageNumber,
										totalItems: totalCount
								  };
						let indx = index
					"
					class="{{
						indx + 1 != packages?.length
							? 'border-b-[1px] border-secondry-color-Gray'
							: ''
					}}"
				>
					<td
						[routerLink]="'edit-package/' + package.id"
						[queryParams]="queryParams"
						class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<span
							class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
						>
							<img
								class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
								[src]="imagePath + package?.image"
								alt=""
								onerror="this.src='assets/images/logo empty state.svg'"
							/>
							<span>
								<span class="block whitespace-normal text-dark-grey">
									{{
										translate.currentLang == 'ar'
											? package?.name?.ar
											: package?.name?.en
									}}
								</span>
							</span>
						</span>
					</td>
					<td
						class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
					>
						{{ package?.packageServices?.length }}
						{{ 'PACKAGES.PACKAGES-LIST.SERVICES' | translate }}
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ package?.startDate | date : 'dd / MM / yyy' : 'UTC' }} <br />
						{{ package?.endDate | date : 'dd / MM / yyy' : 'UTC' }}
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<div class="items-center flex space-x-2 rtl:space-x-reverse">
							<mat-slide-toggle
								[checked]="package?.isActive"
								(change)="tackAction(package, 'ACTIVATE_PACKAGE', $event)"
								hideIcon
							></mat-slide-toggle>
							<span
								class="{{
									package?.isActive ? 'text-[#00BA88]' : 'text-[#B3261E]'
								}}"
								>{{
									(package?.isActive ? 'ACTIONS.ACTIVE' : 'ACTIONS.INACTIVE')
										| translate
								}}</span
							>
						</div>
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<div class="items-center flex space-x-2 rtl:space-x-reverse">
							<mat-slide-toggle
								[checked]="package?.canBook"
								(change)="tackAction(package, 'CAN_BOOK', $event)"
								hideIcon
							></mat-slide-toggle>
							<span
								class="{{
									package?.canBook ? 'text-[#00BA88]' : 'text-[#B3261E]'
								}}"
								>{{
									(package?.canBook
										? 'PACKAGES.PACKAGES-LIST.CAN_BOOK'
										: 'PACKAGES.PACKAGES-LIST.CAN_NOT_BOOK'
									) | translate
								}}</span
							>
						</div>
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						{{ package?.price }}
						{{
							translate.currentLang == 'ar'
								? package?.currency?.name?.ar
								: package?.currency?.name?.en
						}}
					</td>
					<td
						class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
					>
						<span
							[routerLink]="'edit-package/' + package.id"
							[queryParams]="queryParams"
							class="mr-[18px] inline-block max-mobile:w-[20px] w-[16px] mx-2"
						>
							<img
								class="inline-block cursor-pointer"
								[src]="'assets/images/view.svg'"
								alt=""
							/>
						</span>
						<button
							(click)="deletePackage(package)"
							class="mr-[18px] inline-block max-mobile:w-[20px] w-[16px] mx-2"
						>
							<img
								class="inline-block cursor-pointer"
								[src]="'assets/images/delete.svg'"
								alt=""
							/>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
